import { PartialTranslation } from '../translations';

export const da: PartialTranslation = {
  newChat: 'Ny chat',
  search: 'Søg',
  user: 'Bruger',
  settings: 'Indstillinger',
  language: 'Sprog',
  getHelp: 'Få hjælp',
  viewAllPlans: 'Se alle planer',
  learnMore: 'Lær mere',
  logOut: 'Log ud',
  chooseLanguage: 'Vælg sprog',
  chooseYourPreferredLanguage: 'Vælg dit foretrukne sprog',
  searchLanguages: 'Søg sprog...',
  autoDetect: 'Automatisk registrering',
  noLanguagesFound: 'Ingen sprog fundet',
  askAnything: 'Spørg om hvad som helst',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personlig',
  freePlan: 'Gratis plan',
  current: 'Nuværende',
  close: 'Luk',
  archive: 'Arkiver',
  delete: 'Slet',
  confirmDelete: 'Er du sikker på, at du vil slette denne chat?',
  confirmArchive: 'Er du sikker på, at du vil arkivere denne chat?',
  deleteCannotUndo: 'Denne handling kan ikke fortrydes.',
  archiveCanFind: 'Du kan finde den i arkivlisten efter arkivering.',
  
  // 资源面板
  resources: 'Ressourcer',
  addResource: 'Tilføj ressource',
  deleteResource: 'Slet ressource',
  noMatchingResourcesFound: 'Ingen matchende ressourcer fundet',
  noResourcesAvailable: 'Ingen ressourcer tilgængelige',
  hideResources: 'Skjul ressourcer',
  showResources: 'Vis ressourcer',
  
  // 聊天输入框
  typeMessage: 'Skriv en besked...',
  thinkingOptions: 'Tankeindstillinger',
  deleteFile: 'Slet fil',
  clearSelection: 'Ryd udvælgelse',
  addAttachment: 'Tilføj vedhæftning',
  sendMessage: 'Send besked',
  
  // 思考模式选项
  deepInsight: 'Dyb indsigt · Overfladisk analyse',
  deepInsightDesc: 'Hurtig forståelse af nøglepunkter',
  deepExploration: 'Dyb udforskning · Omfattende analyse',
  deepExplorationDesc: 'Flerdimensional dybdegående forskning',
  deepDeconstruction: 'Dyb dekonstruktion · Systematisk argument',
  deepDeconstructionDesc: 'Lag-for-lag progressiv analyse',
  
  // 写作模式选项
  contractReview: 'Kontraktgennemgang · Risikoidentifikation',
  contractReviewDesc: 'Klausulanalyse og overholdelseskontrol',
  textPolish: 'Tekstpolering · Professionelt udtryk',
  textPolishDesc: 'Sprogoptimering og strukturel tilpasning',
  legalDocuments: 'Juridiske dokumenter · Standardudkast',
  legalDocumentsDesc: 'Professionel skrivning af juridiske dokumenter',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Log ind',
  register: 'Registrer dig',
  welcomeBack: 'Velkommen til LawHelper',
  loginSubtitle: 'Din AI Juridiske Forskningsassistent',
  continueWithGoogle: 'Fortsæt med Google',
  continueWithMicrosoft: 'Fortsæt med Microsoft',
  continueWithWeChat: 'Fortsæt med WeChat',
  orContinueWith: 'eller fortsæt med',
  emailTab: 'E-mail',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Indtast din e-mail',
  phonePlaceholder: 'Indtast telefonnummer',
  codePlaceholder: 'Indtast 6-cifret kode',
  sending: 'Sender...',
  verifying: 'Bekræfter...',
  verify: 'Bekræft',
  sendMagicLink: 'Send magisk link',
  getVerificationCode: 'Få kode',
  resendCode: 'Send kode igen',
  resendIn: 'Send igen om',
  magicLinkSent: 'Magisk link sendt til din e-mail',
  magicLinkHint: 'Vi sender et sikkert link til din e-mail',
  otpSent: 'Bekræftelseskode sendt',
  agreeToTerms: 'Ved at fortsætte accepterer du vores',
  privacyPolicy: 'Privatlivspolitik',
  termsOfService: 'Servicevilkår',
  and: 'og',
  privacyTitle: 'Dit privatliv er vigtigt',
  privacyIntro: 'Vi bruger cookies og lignende teknologier for at give dig den bedste oplevelse.',
  essentialCookies: 'Nødvendige cookies',
  essentialDesc: 'Kræves for at hjemmesiden fungerer',
  analyticsCookies: 'Analytiske cookies',
  analyticsDesc: 'Hjælper os med at forbedre vores service',
  marketingCookies: 'Markedsføringscookies',
  marketingDesc: 'Bruges til personligt indhold',
  acceptAll: 'Accepter alle',
  essentialOnly: 'Kun nødvendige',
  customize: 'Tilpas',
  savePreferences: 'Gem indstillinger',
  back: 'Tilbage',
  readPrivacyPolicy: 'Læs vores privatlivspolitik',
  cookiePolicy: 'Cookiepolitik',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI-gennemgang',
  aiDraft: 'AI-udkast',
  smartAssistant: 'Skabelon',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktiver søgning',
  knowledgeSearchDesc: 'AI søger i dine dokumenter',
  clickToDisable: 'Deaktiver',
  clickToEnable: 'Aktiver',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Luk ressourcepanel',
  uploading: 'Uploader %{fileName}...',
  processing: 'Behandler %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploadet',
  uploadError: '✗ Upload fejlet: %{error}',
  quickAnswer: 'Hurtigt svar',
  quickAnswerDesc: 'Hurtigt svar på simple spørgsmål',
  cancelRequest: 'Annuller',
  library: 'Bibliotek',
  filterAll: 'Alle',
  filterChat: 'Chats',
  filterReview: 'Gennemgang',
  filterDraft: 'Udkast',
  filterTemplate: 'Skabelon',
  filterForm: 'Formular',
  thinking: 'Tænker...',
  thinkingProcess: 'Tankeproces',
  analyzingLegalLogic: 'Analyserer juridisk logik...',
  lawhelperThinking: 'Lawhelper tænker...',
  serviceError: 'Servicefejl',
  uploaded: 'Uploadet',
  settingsGeneral: 'Generelt',
  settingsNotifications: 'Notifikationer',
  settingsAppearance: 'Udseende',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Svarnotifikationer',
  settingsResponseNotificationsDesc: 'Notifikation når AI er færdig med svaret',
  settingsColorMode: 'Farvetilstand',
  settingsLight: 'Lys',
  settingsDark: 'Mørk',
  settingsSystem: 'System',
  about: 'Om',
  reviewTitle: 'Dokumentgennemgang',
  exitReview: 'Afslut gennemgang',
  uploadPrompt: 'Upload PDF til gennemgang',
  uploadButton: 'Vælg fil',
  startChatConfig: 'Skriv "Gennemgå dette dokument" for at starte',
  reviewPlaceholder: 'Skriv en besked eller "Gennemgå dette dokument"...',
  analyzing: 'Gennemgår...',
  reviewComplete: 'Gennemgang fuldført',
  issuesFound: '%{count} problemer fundet',
  draftTitle: 'Juridisk dokumentudarbejdelse',
  draftPlaceholder: 'Rediger her eller lad AI generere...',
  analyzingTemplate: 'Analyserer skabelon %{name}...',
  templateAnalyzed: '✅ Skabelon %{name} analyseret!',
  templateAnalysisPrompt: 'Analyser nøgleklausuler i skabelonen',
  parsingFailed: '⚠️ Kunne ikke analysere filen, men du kan beskrive dine behov.',
  generating: 'Genererer...',
  generatedSuccess: '✅ Dokument genereret!',
  drafterWelcome: 'Velkommen til AI-dokumentassistenten',
  drafterYouCan: 'Du kan:',
  drafterUploadTemplate: 'Uploade en skabelon til AI-analyse',
  drafterDescribeNeeds: 'Beskrive dine dokumentkrav',
  drafterLetAiHelp: 'AI hjælper med at skrive kontrakter, aftaler osv.',
  drafterExamples: 'Eksempler:',
  drafterExampleRental: '"Udarbejd en lejekontrakt"',
  drafterExampleLabor: '"Udfyld arbejdskontrakten efter skabelon"',
  drafterInputPlaceholder: 'Beskriv dine dokumentbehov...',
  drafterThinking: 'Tænker...',
  drafterHistoryTitle: 'Historik',
  drafterNoHistory: 'Ingen historik',
  drafterNewChat: 'Ny chat',
  drafterHistory: 'Historik',
  drafterRemoveAttachment: 'Fjern vedhæftning',
  drafterLineHeight: 'Linjehøjde',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Eksporter som Word (.docx)',
  drafterExportPdf: 'Eksporter som PDF',
  drafterSave: 'Gem dokument',
  drafterDownload: 'Download dokument',
  drafterUndo: 'Fortryd',
  drafterRedo: 'Gentag',
  drafterBold: 'Fed',
  drafterItalic: 'Kursiv',
  drafterStrike: 'Gennemstreget',
  drafterUnderline: 'Understreget',
  drafterHighlight: 'Markér',
  drafterLink: 'Indsæt link',
  drafterAlignLeft: 'Venstrejuster',
  drafterAlignCenter: 'Centrer',
  drafterAlignRight: 'Højrejuster',
  drafterAlignJustify: 'Bloktekst',
  drafterList: 'Liste',
  drafterBulletList: 'Punktliste',
  drafterOrderedList: 'Nummereret liste',
  drafterTaskList: 'Opgaveliste',
  drafterOpenResource: 'Åbn ressourcepanel',
  drafterStopGeneration: 'Stop generering',
  drafterAgentMode: 'Agenttilstand aktiv | Klik for normal chat',
  drafterAgentModeOn: 'Agenttilstand aktiv | Klik for normal chat',
  drafterAgentModeOff: 'Normal chattilstand | Klik for agenttilstand',
  drafterUploadAttachment: 'Upload vedhæftning',
  drafterExit: 'Afslut',
  drafterConfirm: 'Bekræft',
  drafterOpenLink: 'Åbn link',
  drafterDeleteLink: 'Slet link',
  drafterQuote: 'Citat',
  workflowTitle: 'AI-workflow',
  workflowRunning: 'Kører...',
  workflowReady: 'Klar',
  workflowCompleted: 'Fuldført',
  workflowStartFailed: 'Workflow kunne ikke starte',
  workflowExecutionFailed: 'Workflow fejlede',
  workflowInterrupted: 'Workflow afbrudt',
  workflowProcessing: 'Behandler...',
  workflowStepsCompleted: 'trin fuldført',
  workflowStepsTotal: 'Workflow fuldført (%{count} trin)',
  acceptChanges: 'Accepter ændringer',
  rejectChanges: 'Afvis ændringer',
  changesAccepted: 'Ændringer accepteret',
  changesRejected: 'Ændringer afvist',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Genstart',
  startDrafting: 'Start udarbejdelse',
  interrupt: 'Stop',
  documentSubject: 'Dokumentemne *',
  documentType: 'Dokumenttype',
  jurisdiction: 'Jurisdiktion',
  specialRequirements: 'Særlige krav (valgfrit)',
  clickStartDrafting: 'Klik "Start udarbejdelse" for at begynde',
  docTypeContract: 'Kontrakt',
  docTypeAgreement: 'Aftale',
  docTypeNotice: 'Meddelelse',
  docTypeLetter: 'Brev',
  docTypePetition: 'Begæring',
  docTypeWill: 'Testamente',
  docTypePowerOfAttorney: 'Fuldmagt',
  countryChina: 'Kina',
  countryUSA: 'USA',
  countryGermany: 'Tyskland',
  countryJapan: 'Japan',
  countryFrance: 'Frankrig',
  countryUK: 'Storbritannien',
  citationVerified: 'Verificeret',
  citationUnverified: 'Ikke verificeret',
  imageLoadFailed: 'Billede kunne ikke indlæses',
  smartDocTitle: 'Smart dokumentassistent',
  smartDocChatTitle: 'AI-dokumentassistent',
  smartDocDropPrompt: 'Slip PDF-fil her',
  smartDocSelectFile: 'Vælg fil',
  smartDocOr: 'eller',
  smartDocWelcomeTitle: 'Velkommen til AI-dokumentassistenten',
  smartDocWelcomeYouCan: 'Du kan:',
  smartDocUploadForAI: 'Uploade skabelon til AI-analyse',
  smartDocDescribeDoc: 'Beskrive dokumentkrav',
  smartDocLetAIDraft: 'AI hjælper med kontrakter',
  smartDocExamples: 'Eksempler:',
  smartDocExampleRental: '"Udarbejd en lejekontrakt"',
  smartDocExampleLabor: '"Udfyld arbejdskontrakten"',
  smartDocInputPlaceholder: 'Beskriv dine dokumentbehov...',
  smartDocRemoveAttachment: 'Fjern vedhæftning',
  smartDocOpenResources: 'Åbn ressourcepanel',
  smartDocExit: 'Afslut',
  reviewStartFailed: 'Gennemgangsworkflow fejlede',
  reviewFailed: 'Gennemgang fejlede',
  reviewFoundIssues: 'Gennemgang fuldført, %{count} problemer fundet.',
  cannotReadStream: 'Kan ikke læse svarstrømmen',
  parseEventFailed: 'Kunne ikke analysere hændelse',
  errorPrefix: 'Fejl',
  unknownError: 'Ukendt fejl',
  file: 'Fil',
  loading: 'Indlæser...',
  localFolders: 'Lokale mapper',
  selectLocalFolder: 'Vælg lokal mappe',
  reselectFolder: 'Skift mappe',
  addToContext: 'Tilføj til chat',
  saveFile: 'Gem',
  renameFile: 'Omdøb',
  fileSaved: 'Fil gemt',
  fileRenamed: 'Fil omdøbt til %{name}',
  browserNotSupported: 'Din browser understøtter ikke lokal mappeadgang',
  noFolderSelected: 'Vælg en lokal mappe for at gennemse filer',
  scanningFolder: 'Scanner mappe...',
  selectFileToPreview: 'Vælg fil til forhåndsvisning',
  aiAnalyze: 'AI-analyse',
};
